import * as fetch from '../../../utils/action'
import { getTotalNumber } from '../totalMethod'
import dataStatisticData from '../datas/data-statistic'
export default {
  cpsPaymentList (ctx, data) {
    return fetch.cpsPaymentList(data).then(res => {
      let result = getTotalNumber(res)
      result.data = dataStatisticData.cpsPaymentList(result.data)
      return result
    })
  },
  // 导出CPS缴费订单
  exportCpsPaymentList (ctx, data) {
    return fetch.exportCpsPaymentList(data).then(res => {
    //   let result = downloadFilename(res)
      return res
    })
  },
  findBranchCompany (ctx) {
    return fetch.findBranchCompany().then(res => {
      return res
    })
  },
  isCompanyValide (ctx) {
    return fetch.isCompanyValide().then(res => {
      return res
    })
  },
  getCurrentBatch (ctx, data) {
    return fetch.getCurrentBatch(data).then(res => {
      let result = res.data
      result = dataStatisticData.getCurrentBatch(result)
      return result
    })
  },
  getgetExceptionList (ctx, data) {
    return fetch.getgetExceptionList(data).then(res => {
      let result = getTotalNumber(res)
      result.data = dataStatisticData.getgetExceptionList(result.data)
      return result
    })
  },
  getExceptionExport (ctx, data) {
    return fetch.getExceptionExport(data).then(res => {
      return res.data
    })
  }
}
